import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Teleport as _Teleport, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-355d7825"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card_text_and_image_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/artiklar/funktionsvariation" }, "denna artikel", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/artiklar/cykla-i-europa" }, "Cykla i Europa", -1))

import TextBlock from "../../blocks/TextBlock.vue";
import ContentWrapper from "../../generics/ContentWrapper.vue";
import PageTitle from "../../blocks/PageTitle.vue";
import CustomCard from "../../generics/CustomCard.vue";
import CustomPic from "../../generics/CustomPic.vue";
import TextImgContentBlock from "../../blocks/TextImgContentBlock.vue";
import meta from "@/data/meta.json";

export default /*#__PURE__*/_defineComponent({
  __name: 'TravelRulesGuide',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent('script'), { type: "application/ld+json" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(meta).TicketRulesGuide), 1)
        ]),
        _: 1
      }))
    ])),
    _createVNode(PageTitle, {
      text: "Det får du ha med på din Tågluff i Europa",
      backgroundImageClass: "background-champs-elysees"
    }),
    _createVNode(ContentWrapper, null, {
      default: _withCtx(() => [
        _createVNode(TextBlock, {
          "header-tag": "h2",
          header: "Oavsett om du är en äventyrslysten resenär med särskilda behov, en ivrig cyklist som vill utforska nya platser, eller en stolt husdjursägare som inte vill lämna din fyrbenta vän bakom dig, har vi täckt dig. Resa med funktionsvariation, cykel eller husdjur på tåg i Europa kan vara en fantastisk upplevelse, och det finns gott om möjligheter att göra det smidigt. I den här artikeln kommer vi att guida dig genom vad du behöver veta för att få ut det mesta av din tågluff i Europa, oavsett ditt specifika behov eller följeslagare. Så låt oss börja med några användbara tips och råd."
        }),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(CustomPic, {
            picturePath: "pictures/bringOnTrip.png",
            height: "12rem"
          }),
          _createVNode(TextBlock, { header: "Resa med en funktionsvariation" }, {
            default: _withCtx(() => [
              _createTextVNode(" Om du är en resenär med en funktionsnedsättning eller nedsatt rörlighet och behöver hjälp längs vägen, kan du ordna denna assistans direkt med transportören. De flesta järnvägsföretag i Europa erbjuder assistans för funktionsnedsatta passagerare. Dessutom krävs ofta en separat bokning för många tåg i hela Europa, särskilt om du reser med rullstol. "),
              _hoisted_2,
              _hoisted_3,
              _createTextVNode(" Du kan hitta mer information om hur du ordnar assistans och var du kan göra reservationer i "),
              _hoisted_4,
              _createTextVNode(". ")
            ]),
            _: 1
          }),
          _createVNode(TextBlock, { header: "Resa med cykel" }, {
            default: _withCtx(() => [
              _createTextVNode(" I många länder är det möjligt att ta med din cykel på tåget. Du kan behöva registrera din cykel eller köpa en särskild cykelbiljett innan du kan ta med cykeln på tåget med dig. För mer information om att resa med cykel, läs artikeln om att "),
              _hoisted_5,
              _createTextVNode(". ")
            ]),
            _: 1
          }),
          _createVNode(TextBlock, { header: "Resa med husdjur" }, {
            default: _withCtx(() => [
              _createTextVNode(" I många länder är det möjligt att ta med ditt husdjur på tåget. Du kanske behöver registrera ditt husdjur eller köpa en särskild biljett för husdjur innan du kan ta med din pälskling på tåget med dig. För mer information om att ta med ditt husdjur på tåget, vänligen kontrollera webbplatserna för det eller de järnvägsbolag du planerar att resa med. ")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})